import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { datePickerFormat } from '../../services/ValidationRules';
import { DatePicker } from '../DateTimePickers/DateTimePickers';

export function DateRangePicker(props) {
  const onFromChange = (date, stringDate) => {
    props.onChange({
      from: date && date.isValid() ? date.utc(stringDate, datePickerFormat).startOf('day').valueOf() : null,
      to: props.value.to,
    });
  };

  const onToChange = (date, stringDate) => {
    props.onChange({
      from: props.value.from,
      to: date && date.isValid() ? date.utc(stringDate, datePickerFormat).endOf('day').valueOf() : null,
    });
  };

  return (
    <div className={props.containerClass}>
      <DatePicker
        clearable
        value={props.value.from === null ? null : moment.utc(props.value.from)}
        placeholder={datePickerFormat}
        format={datePickerFormat}
        onAccept={onFromChange}
        disabled={props.disabled}
      />
      <DatePicker
        clearable
        value={props.value.to === null ? null : moment.utc(props.value.to)}
        placeholder={datePickerFormat}
        format={datePickerFormat}
        onAccept={onToChange}
        disabled={props.disabled}
      />
    </div>
  );
}

DateRangePicker.propTypes = {
  value: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
